import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ActionCard from '../../components/dashboard/ActionCard';
import './SuperAdminDashboard.css';

const SuperAdminDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Redirect if not super admin
  React.useEffect(() => {
    if (user && user.user_type !== 'super_admin') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  if (!user || user.user_type !== 'super_admin') {
    return <div>Access denied. Super admin privileges required.</div>;
  }

  const handleViewPageRequests = () => {
    navigate('/page-requests');
  };

  const handleManageUsers = () => {
    navigate('/user-management');
  };

  return (
    <div className="admin-dashboard-container">
      {/* Hero Section with Stats */}
      <div className="admin-hero">
        <div className="hero-content">
          <div className="hero-header">
            <h1>Super Admin Dashboard</h1>
            <p className="hero-subtitle">Welcome back, {user.name || user.email}</p>
          </div>
        </div>
      </div>

      {/* Main Dashboard Grid */}
      <div className="admin-dashboard-grid">
        {/* Primary Action Card - Page Requests */}
        <ActionCard
          title="Page Requests"
          description="Review and approve creator page requests"
          icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 11l3 3L22 4"></path>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
          }
          badge="23 Pending"
          stats={[
            { label: 'Today', value: '5' },
            { label: 'This Week', value: '18' }
          ]}
          buttonText="Review Requests"
          buttonAction={handleViewPageRequests}
          variant="primary"
          urgent={true}
        />

        {/* Secondary Action Cards */}
        <ActionCard
          title="User Management"
          description="Manage user accounts and permissions"
          icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          }
          buttonText="Manage Users"
          buttonAction={handleManageUsers}
          variant="secondary"
        />

        <ActionCard
          title="System Analytics"
          description="View platform statistics and performance metrics"
          icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="20" x2="18" y2="10"></line>
              <line x1="12" y1="20" x2="12" y2="4"></line>
              <line x1="6" y1="20" x2="6" y2="14"></line>
            </svg>
          }
          buttonText="View Analytics"
          buttonAction={() => navigate('/analytics')}
          variant="secondary"
        />

        <ActionCard
          title="Creator Earnings"
          description="View credit payouts owed to content creators"
          icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
          }
          buttonText="View Earnings"
          buttonAction={() => navigate('/creator-earnings')}
          variant="secondary"
        />

        <ActionCard
          title="Platform Settings"
          description="Configure system-wide settings and preferences"
          icon={
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M12 1v6m0 6v6m5.2-13.2l-4.2 4.2m0 6l4.2 4.2M23 12h-6m-6 0H1m18.2 5.2l-4.2-4.2m0-6l4.2-4.2"></path>
            </svg>
          }
          buttonText="Open Settings"
          buttonAction={() => navigate('/platform-settings')}
          variant="secondary"
        />
      </div>
    </div>
  );
};

export default SuperAdminDashboard;